module.exports = __webpack_public_path__ + "img/DigitalTV_R300E.54f1f8df.png";